import { date, object, SchemaOf, TestContext } from "yup";
import OpeningTime, { CLOSING_TIME, OPENING_TIME } from "./OpeningTime";
import { requiredFieldValidationMessage } from "../Forms/ValidationMessages";
import { nameOf } from "../Utils/nameOf";
import { convertToDateFormat } from "../Utils/dates";

const endTimeIsGreaterThanStartTime = (
  endTime: string | Date | undefined,
  testContext: TestContext
): boolean => {
  const { StartTime } = testContext.parent;
  return endTime ? convertToDateFormat(endTime) > StartTime : false;
};

export const openingTimesSchema: SchemaOf<OpeningTime> = object()
  .shape({
    StartTime: date().required(requiredFieldValidationMessage(OPENING_TIME)),
    EndTime: date().when(nameOf<OpeningTime>("StartTime"), {
      is: (startTime: string | undefined) => startTime !== undefined,
      then: date()
        .test({
          name: "greaterThanStartTime",
          message: "Closing Time should be greater than Opening Time",
          test: endTimeIsGreaterThanStartTime,
        })
        .required(requiredFieldValidationMessage(CLOSING_TIME)),
    }),
  })
  .required();
